export default {
  siteName: "51爆料",
  siteTagline: "搜黑料、看大赛的集合站",
  nav: {
    home: "首页",
    wanghongDasai: "网红每日大赛",
    mingxingBagua: "明星八卦",
    heiliaozhuizong: "黑料追踪",
    chiguaShipin: "吃瓜视频",
    about: "关于我们",
  },
  footer: {
    brandIntro: "51爆料是你搜黑料、看大赛的集合站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频，所有八卦和明星消息都在这里。",
    quickLinks: "快速链接",
    contactUs: "联系我们",
    address: "北京市朝阳区互联网产业园区",
    phone: "400-888-5151",
    email: "contact@51baoliao.com",
    copyright: "© 2026 51爆料. All rights reserved.",
  },
  breadcrumb: {
    home: "首页",
  },
  readMore: "阅读全文",
  viewMore: "查看更多",
  publishDate: "发布日期",
  readTime: "阅读时长",
  views: "次阅读",
  relatedArticles: "相关爆料",
  tags: "标签",
};